import { FC } from "react";
import CheckOutFieldContent from "../../CheckOutFieldContent/CheckOutFieldContent";
import TripDateSelect from "../../DateSelection/TripDateSelect/TripDateSelect";

const CheckOutComponentWeb: FC<any> = ({ icon: Icon, hasError, label, disabledDate, className }) => {
  return (
    <div className="flex w-full flex-1 items-center gap-1 md:w-auto">
      <div className={hasError ? "text-font-danger" : "text-icon-minimal"}>
        <Icon className="h-4! w-4!" />
      </div>
      <CheckOutFieldContent className="m-0! focus:outline-none! focus-within:ring-0! w-full border-none! font-semibold md:flex-1 [&_.ant-form-item-explain-error]:px-4!">
        <TripDateSelect label={label} icon={Icon} disabledDate={disabledDate} className={className} />
      </CheckOutFieldContent>
    </div>
  );
};

export default CheckOutComponentWeb;
